if (typeof VideoBackgroundElement != "function") {
  class VideoBackgroundElement2 extends HTMLElement {
    constructor() {
      super();
      this._eventSuccess = new Event("success");
      this._eventFail = new Event("fail");

      const video = this.querySelector("video");
      if (!video) return;

      video.addEventListener("error", () => {
        this.switchFallback();
      });

      video.addEventListener("playing", () => {
        if (!this.classList.contains("loaded")) {
          this.classList.add("loaded");
          this.dispatchEvent(this._eventSuccess);
        }
      });

      video.addEventListener("stalled", () => {
        if (!this.classList.contains("loaded")) this.switchFallback();
      });

      if (window.matchMedia("(max-width: 767px)").matches) {
        this.loadMobileFallback();
        return;
      }

      const loadVideo = () => {
        video.querySelectorAll("source").forEach((source) => {
          source.src = source.dataset.src;
        });
        video.load();
      };

      const handleIntersection = (entries, observer) => {
        if (entries[0].isIntersecting) {
          const target = entries[0].target;
          const targetElement = target.querySelector("video-background-element");

          if (targetElement && !targetElement.classList.contains("loaded")) {
            loadVideo();
          } else if (target.tagName == "video-background-element" && !target.classList.contains("loaded")) {
            loadVideo();
          }

          observer.unobserve(this);
        }
      };

      if (this.getBoundingClientRect().y < window.innerHeight * 0.3 || this.parentNode.getBoundingClientRect().y < window.innerHeight * 0.3) {
        loadVideo();
      } else {
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this.parentElement);
      }
    }

    switchFallback() {
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if (fallback && !fallback.querySelector("img")) {
        fallback.append(fallback.querySelector("template").content.cloneNode(true));
        fallback.querySelector("img").setAttribute("srcset", fallback.querySelector("img").getAttribute("srcset"));
      }
      this.dispatchEvent(this._eventFail);
    }

    loadMobileFallback() {
      const revealFallback = () => this.switchFallback();
      const elementTop = this.getBoundingClientRect().top;
      const parentTop = this.parentElement.getBoundingClientRect().top;

      if (elementTop < window.innerHeight * 0.85 || parentTop < window.innerHeight * 0.85 || !("IntersectionObserver" in window)) {
        revealFallback();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          revealFallback();
          observer.unobserve(this);
        }
      }, { rootMargin: "0px 0px 120px 0px" });

      observer.observe(this);
    }
  }

  if (typeof customElements.get("video-background-element") > "u") {
    customElements.define("video-background-element", VideoBackgroundElement2);
  }
}

document.addEventListener("shopify:section:load", (event) => {
  if (!event.target.classList.contains("mount-video-background")) return;

  setTimeout(() => {
    event.target.querySelectorAll("video-background-element").forEach((element) => {
      if (window.matchMedia("(max-width: 767px)").matches) {
        element.loadMobileFallback();
        return;
      }

      element.querySelectorAll("source").forEach((source) => {
        source.src = source.dataset.src;
      });
      element.querySelector("video").load();
    });
  }, 500);
});
